import { GroupTypes } from "../../../../enum/GroupTypes";
import { getNodeById } from "../../../../nodeSelector";
import * as nodeUtils from "../../../../utils/nodeUtils";
import * as pathUtils from "../../../../utils/pathUtils";
import { moveChoiceFlat } from "../moveChoiceFlat";

export const moveChoiceAdapter = (root, id, idDestination, relVertical, offset) => {
  const _nodeDestination = getNodeById(root, idDestination);
  const _isDstParameter = nodeUtils.isParameter(_nodeDestination.data);

  if (_isDstParameter || relVertical) {
    return moveToTop(root, id, idDestination);
  } else {
    return moveToTarget(root, id, idDestination, offset);
  }
};

const moveToTop = (root, id, idParameter) => {
  return moveChoice(root, id, idParameter);
};

const moveToTarget = (root, id, idChoice, offset) => {
  const _idParent = pathUtils.getIdParent(idChoice);
  let { index: _index } = getNodeById(root, idChoice);

  if (_index) {
    if (getNodeById(root, id)?.index < _index && pathUtils.getIdParent(id) === _idParent) {
      _index--;
    }
  }

  return moveChoice(root, id, _idParent, _index + offset);
};

const moveChoice = (root, id, idTargetParent, index) => {
  const groupAction = pathUtils.determineGroup(id, idTargetParent);

  switch (groupAction) {
    case GroupTypes.INTERNAL_GLOBALS:
    case GroupTypes.INTERNAL_FUNCTIONS:
      return moveChoiceFlat(root, id, idTargetParent, index);
    case GroupTypes.TO_GLOBALS:
    case GroupTypes.TO_FUNCTIONS:
    default:
      return { root };
  }
};
